export {
  getMessageFiles,
  getMessageText,
  mapStoredMessage,
} from "@fitness-app/client-shared/features/sales-agent";

export const copyTextToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      if (!document.execCommand("copy")) throw new Error("execCommand copy failed");
    } finally {
      document.body.removeChild(textarea);
    }
  }
};
